var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"bordered":"","columns":_vm.columns,"components":_vm.components,"data-source":_vm.data,"rowKey":function (record) { return record.id; },"expandedRowKeys":_vm.expandedRowKeys}})}
var staticRenderFns = []

export { render, staticRenderFns }